import Facebook from './channels/Facebook';
import Website from './channels/Website';
import Twitter from './channels/Twitter';
import Api from './channels/Api';
import Email from './channels/Email';
import Sms from './channels/Sms';
import Call from './channels/Call.vue';
import Whatsapp from './channels/Whatsapp';
import Line from './channels/Line';
import Telegram from './channels/Telegram';
import WhatsappCommunal from './channels/WhatsappCommunal';
import WhatsappPersonal from './channels/WhatsappPersonal.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  ['twilio call']: Call,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  whatsappCommunal: WhatsappCommunal,
  ['whatsapp personal']: WhatsappPersonal,
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
      },
      name: 'new-channel-view',
      render(h) {
        return h(channelViewList[this.channel_name] || null);
      },
    };
  },

  disableInboxCreate(channelKey,user,inboxes,{currentAccount}){
    // only allowed
    switch (channelKey) {
      // for the grant user, can create only one whatsapp inbox. disable if created one
      case 'whatsapp':
        // const isGrantUser = user.plan_id === 20;
        // const existingWhatsappinboxes = inboxes.filter(inbox=>inbox.channel_type === "Channel::Whatsapp");
        // const existingWhatsappinboxes = inboxes.filter(inbox=>(inbox.channel_type === "Channel::Whatsapp") && !inbox.communal_type);
        // if (isGrantUser && existingWhatsappinboxes.length > 0) {
        //   return true;
        // }
        return false;

      case 'whatsapp communal':
        // if one communal inbox exist, disable to create more
        const existingCommunalInboxes = inboxes.filter(inbox=>inbox.communal_type);
        if (existingCommunalInboxes.length > 0) {
          return true;
        }
        return false;

        // for whatsapp personal, allow by limit else 1
      case 'whatsapp personal':
        let totalLimit = 1;
        if (currentAccount?.limits?.wa_personals > 0) {
          totalLimit = currentAccount?.limits?.wa_personals;
        }
        const existPersonalWA = inboxes.filter(el=>el.whatsapp_personal);
        console.log({existPersonalWA,totalLimit});
        if (existPersonalWA.length >= totalLimit) {
          return true;
        }
        return false


      default:
        return false;
    }
  },

};
